<template>
    <div id="app">
        <app-header v-if="!onPublicRoute" ref="header"></app-header>
        <guide-sidebar />
            <div id="body" style="height: calc(100vh - 50px); overflow: auto;">
                <div id="container" class="container is-fluid">
                    <event-monitor />
                    <b-loading :active="$store.getters.routeIsLoading"></b-loading>
                    <router-view />
                </div>
            </div>
        <!-- <app-footer v-if="!onPublicRoute"></app-footer> -->
    </div>
</template>

<script>
    import { DictionaryService } from "@/services/dictionary.service";
    import { TerminologyService } from "@/services/terminology.service";;
    import GuideSidebar from "@/components/Guide/GuideSidebar";

    export default {
        name: 'App',
        components: {
            GuideSidebar,
        },
        computed: {
            onPublicRoute: function() {
                return _.get(this.$route, 'meta.public') ? true : false;
            },
            dictionary() {
                return this.$store.getters["Auth/dictionary"];
            }
        },
        watch: {
            '$route': function(next, from) {
                if (this.$refs.header) {
                    this.$store.state.headerHeight = this.$refs.header.$el.clientHeight;
                }
            },
            dictionary: {
                handler(value) {
                    this.$i18n.locale = value;
                },
                immediate: true
            }
        },
        mounted() {
            var idleHeight = document.getElementById('body').offsetHeight - document.getElementById('container').offsetHeight;
            this.$store.commit("_SET_IDLE_HEIGHT", idleHeight);
            // Removed this because on some routes the header is not rendered.
            // this.$store.state.headerHeight = this.$refs.header.$el.clientHeight;

            // Set i18n messages
            // DictionaryService.all().then(response => {
            //     const messages = response.data;

            //     Object.keys(messages).forEach(locale => {
            //         this.$i18n.setLocaleMessage(locale, messages[locale]);
            //     });

            //     console.log(this.$i18n)
            // })
            TerminologyService.locale().then(response => {
                const messages = response.data;

                Object.keys(messages).forEach(locale => {
                    this.$i18n.setLocaleMessage(locale, messages[locale]);
                });
            })
        }
    }
</script>

<style>
    /*@import url('//fonts.googleapis.com/css?family=Roboto');*/
    @import url('//cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
</style>

<style src="./buefy-custom.scss" lang="scss"></style>
<style src="./main.css"></style>

<style scoped>
    .loading-overlay.is-active {
        z-index: 99;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue